<template>
  <el-select
    v-model="selected"
    v-loadmore="getChipModelList"
    clearable
  >
    <el-option
      v-for="item in chipModelList"
      :key="item.value"
      :label="item.label"
      :value="item.value"
    ></el-option>
  </el-select>
</template>
<script>
import { getChipModelList } from '@/api/notRoadFour/chipModel.js';

export default {
  name: '',
  components: {},
  model: {
    prop: 'data',
    event: 'onDataChange'
  },
  props: {
    data: {
      type: [String, Number],
      default: () => ''
    },
    hasAll: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      selected: '',
      chipModelList: [],
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      }
    };
  },
  computed: {},
  watch: {
    selected: {
      handler(selected) {
        this.$emit('onDataChange', selected);
      }
    },
    data: {
      handler(data) {
        this.selected = data;
      }
    }
  },
  created() {
    if (this.hasAll) {
      this.chipModelList.push({ value: '', label: '全部' });
    }
    this.selected = this.data;
    this.getChipModelList();
  },
  mounted() {},
  methods: {
    async getChipModelList() {
      const { pageNum, pageSize, total } = this.pagination;
      if ((pageNum - 1) * pageSize > total) {
        return;
      }
      const params = {
        pageNum,
        pageSize
      };
      const { data } = await getChipModelList(params);
      const chipModelList = data.list.map((item) => {
        return {
          value: item.chipModel,
          label: item.chipModel
        };
      });
      this.chipModelList.push.apply(this.chipModelList, chipModelList);
      this.pagination.total = data.total;
      this.pagination.pageNum += 1;
    }
  }
};
</script>
<style scoped lang="scss">
</style>
